export { TermsAndConditions } from "./TermsAndConditions";
